import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useMemo, useState } from 'react';

import { ShareParams } from './types';

interface ShareOnSocialsProviderProps {
  children: ReactNode;
}

const ShareOnSocialsStateContext = createContext<
  | {
      shareParams: ShareParams;
      setShareParams: Dispatch<SetStateAction<ShareParams>>;
    }
  | undefined
>(undefined);

const ShareOnSocialsProvider = ({ children }: ShareOnSocialsProviderProps) => {
  const [shareParams, setShareParams] = useState<ShareParams>({});

  const contextValue = useMemo(() => ({ shareParams, setShareParams }), [shareParams, setShareParams]);

  return <ShareOnSocialsStateContext.Provider value={contextValue}>{children}</ShareOnSocialsStateContext.Provider>;
};

const useShareParams = () => {
  const context = useContext(ShareOnSocialsStateContext);
  if (!context) throw new Error('useShareParams must be used within a ShareOnSocialsProvider');
  return context;
};

export { ShareOnSocialsProvider, useShareParams };
